import React from 'react';

import Button from '@app/common/components/Button';
import Icon, { Icons } from '@app/common/components/Icon';
import { HeaderProps } from '../../types';

import styles from './Header.module.scss';

const Header: React.FC<HeaderProps> = ({ step, getModalTitle, onClose }) => (
    <div className={styles.customHeader}>
        <div className={styles.headerContent}>
            <div className={styles.headerText}>
                <h2 className={styles.modalTitle}>{getModalTitle()}</h2>
                {step === 'select' && (
                    <p className={styles.modalSubtitle}>Select the plan you would like to change to.</p>
                )}
            </div>
            <Button type="button" onClick={onClose} className={styles.closeButton}>
                <Icon icon={Icons.CLOSE} />
            </Button>
        </div>
    </div>
);

export default Header;